export const createPrefixTree = (word_payloads: any) => {
    let tab = {}

    if (word_payloads) {
        //@ts-ignore
        word_payloads.forEach(([word, payload], i: number, arr: any) => {
            let row_no = 0
            for (let j = 0; j < word.length; j++) {
                const ch = word[j]
                const key = [row_no, j, ch]
                //@ts-ignore
                const child = tab[key]

                if (child) {
                    const child_id = child[0]
                    row_no = child_id
                } else {
                    const final = j + 1 === word.length
                    //@ts-ignore
                    tab[key] = [i, final, final ? payload : null]
                    row_no = i
                }
            }
        })
    }

    return {
        tab: tab,
        lookup(node_id: any, offset: any, ch: any) {
            //@ts-ignore
            const child = this.tab[[node_id, offset, ch]]

            return child ? child : null
        },
    }
}
